document.addEventListener('DOMContentLoaded', function () {
  const headerSelectors = [
    '.avone-header',
    '.site-header',
    '#shopify-section-header',
    '.header-wrapper',
    '.header',
    '#Header'
  ];

  function getHeaderHeight() {
    for (let sel of headerSelectors) {
      const el = document.querySelector(sel);
      if (el) return Math.ceil(el.getBoundingClientRect().height);
    }
    return 0;
  }

  function scrollToElementWithOffset(target, offset = 0, margin = 60) {
    const rect = target.getBoundingClientRect();
    const top = window.scrollY + rect.top - offset - margin;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  // Applica al megamenu: usa selector specifico se Avone usa custom class (es. .megamenu, .main-menu)
  document.querySelectorAll('details.sumtabs, details.megamenu, details[data-mega]').forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (!details.open) return;
      const headerHeight = getHeaderHeight();
      const target = details.querySelector('.dropdown-inner') || details;
      if (!target) return;
      scrollToElementWithOffset(target, headerHeight, 60);
    });
  });
});
